import styled from 'styled-components';
import 'rsuite/dist/rsuite.min.css';
import { theme } from '../../styles/constants';

export const Container = styled.div`
  .rs-picker-input-group {
    background-color: transparent;
    border: 1px solid #f3f4f6;
    border-radius: 8px;
    height: 3.6rem;

    &:hover {
      border-color: #f3f4f6;
    }

    svg {
      color: white;
    }
  }

  .rs-input-group-addon {
    display: none;
  }

  .rs-picker-input-group {
    background-color: transparent;
    border: 1px solid #f3f4f6;

    &:hover {
      border-color: #f3f4f6;
    }

    svg {
      color: ${theme.colors.textColor};
    }
  }

  .rs-input-group {
    &:focus-within {
      outline: none;
      border-color: #f3f4f6;
    }
  }

  .rs-input-group-focus {
    border: 1px solid #f3f4f6;
    outline: none;

    &:hover {
      border-color: #f3f4f6;
    }
  }

  .rs-input {
    background-color: transparent;
    color: ${theme.colors.textColor};
    font-weight: 400;
    cursor: pointer;

    &::placeholder {
      color: ${theme.colors.textColor};
      font-weight: 300;
    }
  }
`;
